"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Generators = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const generator_1 = require("./declarativeAgent/generator");
const defaultGenerator_1 = require("./defaultGenerator");
const generator_2 = require("./officeAddin/generator");
const customEngineAgentGenerator_1 = require("./openApiSpec/customEngineAgentGenerator");
const declarativeAgentGenerator_1 = require("./openApiSpec/declarativeAgentGenerator");
const messageExtensionGenerator_1 = require("./openApiSpec/messageExtensionGenerator");
const ssrTabGenerator_1 = require("./other/ssrTabGenerator");
const tdpGenerator_1 = require("./other/tdpGenerator");
const spfxGenerator_1 = require("./spfx/spfxGenerator");
// When multiple generators are activated, only the top one will be executed.
exports.Generators = [
    // TDP is the first generator because it reuses some templates from other generators.
    new tdpGenerator_1.TdpGenerator(),
    // Generators below does not have overlapping templates.
    new defaultGenerator_1.DefaultTemplateGenerator(),
    new generator_2.OfficeAddinGeneratorNew(),
    new spfxGenerator_1.SPFxGeneratorNew(),
    new spfxGenerator_1.SPFxGeneratorImport(),
    new ssrTabGenerator_1.SsrTabGenerator(),
    new declarativeAgentGenerator_1.DeclarativeAgentWithExistingApiSpecGenerator(),
    new customEngineAgentGenerator_1.CustomEngineAgentWithExistingApiSpecGenerator(),
    new messageExtensionGenerator_1.MessageExtensionWithExistingApiSpecGenerator(),
    new generator_1.DeclarativeAgentGenerator(),
];
//# sourceMappingURL=generatorProvider.js.map